package org.example.project.utils

import kotlinx.browser.document
import kotlinx.browser.window
import org.w3c.dom.HTMLAudioElement

object AudioManager {

    private var backgroundMusic: HTMLAudioElement? = null
    private var musicStarted = false

    fun playBackgroundMusic() {

        if (backgroundMusic == null) {
            backgroundMusic = document.createElement("audio") as HTMLAudioElement
            backgroundMusic!!.src = "music/bgm.mp3"
            backgroundMusic!!.loop = true
            backgroundMusic!!.volume = 0.35
            document.body?.appendChild(backgroundMusic!!)
            backgroundMusic!!.load()

            try {
                backgroundMusic!!.play()
                    .then {
                        println("Background music started")
                    }
                    .catch {
                        println("Failed to start music: $it")
                    }
            } catch (e: Throwable) {
                println("Could not start background music: ${e.message}")
            }
        }
    }
    fun startMusicOnFirstInteraction() {
        if (musicStarted) return
        musicStarted = true
        playBackgroundMusic()
    }
    private fun playEffect(file: String) {

        val effect =
            document.createElement("audio") as HTMLAudioElement

        effect.src = file
        effect.volume = 0.8
        effect.play().catch{
            println("Error occurred while playing sound: $file")
        }
    }
    fun playSplash() {
        playEffect("music/splash.mp3")
    }

    fun playTorpedo() {
        playEffect("music/torpedo.mp3")
    }

    fun playSystemDownSound(){
        playEffect("music/systemdown.mp3")
    }

    fun playClusterBomb() {
        playEffect("music/cluster_bomb.mp3")
    }

    fun playCrossFire() {
        playEffect("music/cross_fire.mp3")
    }

    fun playSonarPing() {
        playEffect("music/sonar_ping.mp3")
    }
    fun playLineStrike(){
        window.setTimeout({
            playEffect("music/torpedo.mp3")
        }, 0)

        window.setTimeout({
            playEffect("music/torpedo.mp3")
        }, 500)

        window.setTimeout({
            playEffect("music/torpedo.mp3")
        }, 1000)
    }
    fun playVictory(){
        playEffect("music/victory.mp3")
    }
    fun playDefeat(){
        playEffect("music/defeat.mp3")
    }
    fun stopMusic() {

        backgroundMusic?.pause()
    }

    fun setVolume(
        volume: Float
    ) {

        backgroundMusic?.volume = volume.toDouble()
    }

    fun mute() {

        backgroundMusic?.muted = true
    }

    fun unMute() {

        backgroundMusic?.muted = false
    }
}